const waitlistHu = {
    "not_enabled": "A várólista funkció nincs engedélyezve ehhez az étteremhez.",
    "waitlist_item": "Várólista elem",
    "no_waitlist_items": "Nincsenek vendégek a várólistán.",
    "guest_name": "Vendég neve",
    "phone": "Telefonszám",
    "number_of_guests": "Vendégek száma",
    "add_guest": "Vendég hozzáadása",
    "added_successfully": "Vendég hozzáadva a várólistához.",
    "added_failed": "Vendég hozzáadása sikertelen.",
    "guest_removed": "Vendég eltávolítva a várólistáról.",
    "arrived": "Megérkezett",
    "send_sms": "SMS küldése",
    "delete": "Törlés",
    "confirm_delete": "Biztosan törölni szeretné ezt a vendéget a várólistáról?",
    "converted_to_reservation": "Foglalás létrehozva",
    "conversion_failed": "Foglalás létrehozása sikertelen.",
    "sms_text": "SMS szövege",
    "sms_placeholder": "Írja be az SMS szövegét...",
    "send_message": "Üzenet küldése",
    "language": "Nyelv",
    "currently_waitlist": "Jelenlegi ennyien várakoznak",
    "sms_sent": "SMS elküldve.",
    "sms_failed": "SMS küldése sikertelen.",
    "template_by_language": "Elmentett sablon nyelv szerint",
    "add_new_waitlist": "Új várakozás létrehozása",
}

export default waitlistHu;